import { Image, Modal, styled } from '@teko/ds-desktop';
import { useDistanceTerminalContext } from 'contexts';
import * as React from 'react';
import { useEffect } from 'react';
import { PopupTerminalPickerProps } from '..';
import TerminalPicker from '../../../../assets/terminal-picker.png';
import { ModeEnterAddress } from './ModeEnterAddress';
import { ModeListTerminal } from './ModeListTerminal';

export const PopupTerminalPickerDesktop: React.FC<
  Omit<PopupTerminalPickerProps, 'isMobile'>
> = ({ onClosePopup, showPopup }) => {
  const {
    isModeEnterAddress,
    locationGetDistanceTerminals,
    currentTerminals,
    setTemporaryDataDistanceTerminal,
    temporaryDataDistanceTerminal,
  } = useDistanceTerminalContext();

  useEffect(() => {
    if (!!showPopup) {
      setTemporaryDataDistanceTerminal?.({
        ...temporaryDataDistanceTerminal,
        terminals:
          !!currentTerminals && Array.isArray(currentTerminals)
            ? currentTerminals
            : [],
        ...(locationGetDistanceTerminals
          ? { location: locationGetDistanceTerminals }
          : {}),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTerminals, locationGetDistanceTerminals, showPopup]);

  return (
    <Modal
      visible={showPopup}
      onClose={onClosePopup}
      showCloseIcon={false}
      footer={false}
      width={700}
      contentStyle={{ borderRadius: '24px' }}
    >
      <Wrapper>
        <div style={{ marginBottom: 12, textAlign: 'center' }}>
          <Image src={TerminalPicker} width={160} height={100} />
        </div>
        {isModeEnterAddress ? <ModeEnterAddress /> : <ModeListTerminal />}
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  padding: 32px 8px;
`;
